/* istanbul ignore file */

/* eslint-disable react/require-default-props */
import React from 'react';
import { string } from 'prop-types';

var NavLinks = function NavLinks(_ref) {
  var linkName = _ref.linkName,
      href = _ref.href,
      anchorName = _ref.anchorName,
      target = _ref.target;
  return /*#__PURE__*/React.createElement("li", {
    className: "list-item ".concat(linkName)
  }, /*#__PURE__*/React.createElement("a", {
    className: "anchor",
    target: target,
    href: href
  }, anchorName));
};

NavLinks.propTypes = {
  /**
   * Identifier className
   */
  linkName: string,

  /**
   * Define a URL.
   */
  href: string,

  /**
   * Anchor's children
   */
  anchorName: string,

  /**
   * Define a target if anchor is true.
   */
  target: string
};
export default NavLinks;